/**
 * @author        quanquan
 * @dateTime      2020-12-09 14:19:41
 * @description   meituanIM mutations
 */

import { store } from './utils'

export default {
  /**
   * reset store
   */
  setResetStore (state) {
    _.assign(state, _.cloneDeep(store))
  },
  /**
   * 设置美团客服在线状态
   */
  setCurrentCsMtStatus (state, payload) {
    state.currentCsMtStatus = payload
  },
  /**
   * 设置客服在线状态
   */
  setCurrentCsStatus (state, payload) {
    state.currentCsStatus = payload
  },
  /**
   * 设置ws连接
   */
  setIMWebsocket (state, payload) {
    const { key, value } = payload
    state.IMWebsocket[key] = value
  },
  /**
   * 缓存密钥列表
   */
  setCacheAppSecret (state, payload) {
    state.cacheAppSecret = payload
  },
  /**
   * 设置单条门店记录
   */
  setMtImStoreItem (state, payload) {
    const item = _.find(state.mtImStoreData, ['onlineStoreCode', payload.onlineStoreCode])
    if (_.isEmpty(item)) {
      state.mtImStoreData.unshift(payload)
    } else {
      state.mtImStoreData = _.reject(state.mtImStoreData, ['onlineStoreCode', payload.onlineStoreCode])
      const t = _.assign(item, payload)
      state.mtImStoreData.unshift(t)
    }
  },
  /**
   * 设置全部门店数据
   */
  setMtImStoreData (state, payload) {
    state.mtImStoreData = payload
  },
  /**
   * 设置单条用户记录
   */
  setMtImUserItem (state, payload) {
    const item = _.find(state.mtImUserData, ['thirdUserId', payload.thirdUserId])
    if (_.isEmpty(item)) {
      state.mtImUserData.unshift(payload)
    } else {
      state.mtImUserData = _.reject(state.mtImUserData, ['thirdUserId', payload.thirdUserId])
      const t = _.assign(item, payload)
      state.mtImUserData.unshift(t)
    }
  },
  /**
   * 设置全部用户数据
   */
  setMtImUserData (state, payload) {
    state.mtImUserData = payload
  },
  /**
   * 设置最新用户信息
   */
  setNewMtImUserData (state, payload) {
    state.mtImUserData = payload
  },
  /**
   * 设置门店查询参数
   */
  setStoreSearchParams (state, payload) {
    state.storeSearchParams = _.assign(state.storeSearchParams, payload)
  },
  /**
   * 设置用户查询参数
   */
  setUserSearchParams (state, payload) {
    state.userSearchParams = _.assign(state.userSearchParams, payload)
  },
  /**
   * 设置选用户id
   */
  setMsgSearchParams (state, payload) {
    state.msgSearchParams = _.assign(state.msgSearchParams, payload)
  },
  /**
   * 单挑消息集
   */
  setCacheSingleMsg (state, payload) {
    state.cacheSingleMsg = payload
  },
  /**
   * 设置聊天数据
   */
  setMtImMsgData (state, payload) {
    state.mtImMsgData = payload
  },
  /**
   * 设置单条聊天数据
   */
  setSingleMtImMsgData (state, payload) {
    state.mtImMsgData.push(payload)
  },
  /**
   * 设置多条聊天数据
   */
  setManyMtImMsgData (state, payload) {
    state.mtImMsgData = [...payload, ...state.mtImMsgData]
  },
  /**
   * 设置上报数据
   */
  setCacheStoresItemData (state, payload) {
    state.cacheStoresData.push(payload)
  },
  /**
   * 设置上报数据
   */
  setCacheStoresData (state, payload) {
    state.cacheStoresData = payload
  },
  /**
   * 设置ws rongCloud状态
   */
  setRongStatus (state, payload) {
    state.rongStatus = payload
  },
  /**
   * 设置ws meituanIM状态
   */
  setMtStatus (state, payload) {
    state.mtStatus.push({ status: payload.status, appId: _.split(payload.appId, '_')[0] })
  },
  /**
   * 缓存当前聊天框消息
   */
  setCacheCurrentChatBoxMsg (state, payload) {
    state.cacheCurrentChatBoxMsg = payload
  },
  /**
   * 设置是否更多消息标记
   */
  setIsMsgMore (state, payload) {
    state.isMsgMore = payload
  }
}



// WEBPACK FOOTER //
// ./src/js/conf/home/store/meituanIM/mutations.js